
import React from 'react';
import { Switch } from 'antd';

const BaseSwitch = (props) => {

  return (
    <Switch { ...props } />
  )

};

export default BaseSwitch;